module.exports = "<div class=\"text-center\">\n\t<img class=\"logo center\" src=\"/assets/next_agenda_welcome.jpg\" />\n\t<h3> Comincia subito, crea una nuova agenda!</h3>\n\t<button class=\"btn btn-sm btn-success\" role=\"button\" (click)=\"addAgenda()\">\n\t\t<i class=\"fa fa-2x fa-plus\" aria-hidden=\"true\"></i>\n\t</button>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/welcome/welcome.html
// module id = ./src/app/home/welcome/welcome.html
// module chunks = main